import { Box, Flex, Text } from '@chakra-ui/react'
import { useKanguCargobr } from '../../../../../contexts/KanguCargobrContext'

export function ResumoCubagem({ isAgrupped, infoAgrupped, proximaCaixa }) {
  const { summary } = useKanguCargobr()

  return (
    <Flex
      maxW="fit-content"
      w="100%"
      mt="1rem"
      gap={3}
      border="1px solid #cecece"
      textTransform="uppercase"
      paddingBlock="1rem"
      alignItems="center"
      justifyContent="space-between"
      position={'relative'}
    >
      {isAgrupped && (
        <Text
          as="span"
          m="0"
          fontSize="11px"
          textAlign="start"
          position="absolute"
          top="0"
          left="0"
          bg="#e9e9e9"
        >
          Caixas agrupadas
        </Text>
      )}

      <Flex position="relative">
        <Text
          as="span"
          m="0"
          textAlign="start"
          paddingLeft="1.5rem"
          paddingRight="1.8rem"
        >
          Total de caixas:{' '}
          <Text as="span" fontWeight={'bold'} color="#95c620">
            {!isAgrupped ? summary?.quantidadeTotal : '1'}
            {` `}
            unidades
          </Text>
        </Text>
        <Box w="2px" h="25px" bg="#cecece" marginRight="1rem" />
      </Flex>

      <Text as="span" m="0" textAlign="end" alignSelf="end" paddingRight="1rem">
        Peso total:{' '}
        <Text as="span" fontWeight={'bold'} color="#95c620">
          {!isAgrupped
            ? parseFloat(summary?.pesoTotal).toFixed(2)
            : parseFloat(infoAgrupped?.pesoTotalAgrupado).toFixed(2)}
          kg
        </Text>
      </Text>
      {isAgrupped && (
        <>
          <Box w="2px" h="25px" bg="#cecece" marginRight="1rem" />
          <Text as="span" m="0" fontSize="1rem" textAlign="start">
            Caixa Agrupada:{' '}
            <Text as="span" fontWeight={'bold'} paddingRight="3rem">
              {' '}
              {proximaCaixa?.value}
            </Text>{' '}
          </Text>
        </>
      )}
    </Flex>
  )
}
